import type { InjectionKey, Ref } from 'vue'

// App owns the canonical browser-session/access snapshot. Historical match
// surfaces consume this signal so logout or access revocation immediately
// removes already-rendered private content without waiting for a focus poll.
export const playerHistoricalAccessAllowedKey: InjectionKey<Readonly<Ref<boolean>>> = Symbol(
  'player-historical-access-allowed',
)
